var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "circle",
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0277FB"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text",
    x: "50%",
    y: "50%",
    alignmentBaseline: "middle",
    textAnchor: "middle",
    fontSize: 16,
    fontWeight: "bold",
    fill: "white"
  }, "MS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.934ec706cd5fb31d6fe2f5315e03f60c.svg";
export { ForwardRef as ReactComponent };